import Showcase from "@/components/Showcase"
import Contact from "@/components/ContactSeparator"
import MainHeading from "@/components/MainHeading"

export default {
  name: "Home",
  components: {
    Showcase,
    Contact,
    MainHeading
  },
  props: [
    'location'
  ],
  data() {
    return {
      resumeItems: [
        {
          name: "Education",
          isExpanded: false,
          showcase: 'resume',
          cards: [
            {
              subtitle: 'University of',
              title: 'Cincinnati',
              canCollapse: true,
              dates: ['2019-2023'],
              dateNames: [],
              info: [
                'College of Design, Architecture, Art, and Planning',
                'Bachelor of Science in Architecture',
                'GPA: 3.6',
              ]
            },
            {
              subtitle: 'Mars Area',
              title: 'High School',
              canCollapse: true,
              dates: ['2015-2019'],
              dateNames: [],
              info: [
                'Mars, Pennsylvania',
                'GPA: 3.8'
              ]
            }
          ]
        },
        {
          name: "Activities",
          isExpanded: false,
          showcase: 'resume',
          cards: [
            {
              subtitle: 'Schneider Hall',
              title: 'Floor President',
              canCollapse: true,
              dates: ['2019-2020'],
              dateNames: [],
              info: [
                'Communicate events with the floor',
                'Gather feedback from the floor for events',
                'Plan events and request funds'
              ]
            },
            {
              subtitle: 'Marching Band',
              title: 'Section Leader',
              canCollapse: true,
              dates: ['2014-2019', '2017-2019'],
              dateNames: ['Member', 'Section Leader'],
              info: [
                'Teach the new members how to properly march',
                'Aid members with learning and memorizing the music',
                'Help members understand where they should be at on the football field at a designated time'
              ]
            }
          ]
        },
        {
          name: "Work Experience",
          isExpanded: false,
          showcase: 'resume',
          cards: [
            {
              subtitle: 'Giant Eagle',
              title: 'Cashier',
              canCollapse: true,
              dates: ['2017-2020'],
              dateNames: [],
              info: [
                'Ring and bag items for customers',
                'Greet customers and make sure they know where to go to find particular items',
                'Ensure the front of the store remains clean and safe'
              ]
            },
          ]
        },
        {
          name: "Skills",
          isExpanded: false,
          showcase: 'resume',
          cards: [
            {
              subtitle: 'Microsoft Word',
              title: '',
              canCollapse: false,
              dates: [],
              dateNames: [],
              info: []
            },
            {
              subtitle: 'Microsoft Powerpoint',
              title: '',
              canCollapse: false,
              dates: [],
              dateNames: [],
              info: []
            },
            {
              subtitle: 'Microsoft Excel',
              title: '',
              canCollapse: false,
              dates: [],
              dateNames: [],
              info: []
            },
            {
              subtitle: 'Google Docs',
              title: '',
              canCollapse: false,
              dates: [],
              dateNames: [],
              info: []
            },
            {
              subtitle: 'Photoshop',
              title: '',
              canCollapse: false,
              dates: [],
              dateNames: [],
              info: []
            },
            {
              subtitle: 'Lightroom',
              title: '',
              canCollapse: false,
              dates: [],
              dateNames: [],
              info: []
            },
            {
              subtitle: 'Revit',
              title: '',
              canCollapse: false,
              dates: [],
              dateNames: [],
              info: []
            },
            {
              subtitle: 'Auto CAD',
              title: '',
              canCollapse: false,
              dates: [],
              dateNames: [],
              info: []
            },
            {
              subtitle: `Beginner in
                        Rhino, Illustrator, Indesign`,
              title: '',
              canCollapse: false,
              dates: [],
              dateNames: [],
              info: []
            },
          ]
        },
        {
          name: "Honors",
          isExpanded: false,
          showcase: 'resume',
          cards: [
            {
              subtitle: 'Mars Area High School',
              title: 'High Honors',
              canCollapse: false,
              dates: ['2015-2019'],
              dateNames: [],
              info: []
            },
            {
              subtitle: 'French',
              title: 'Honors Society',
              canCollapse: false,
              dates: ['2018-2019'],
              dateNames: [],
              info: []
            },
            {
              subtitle: 'College of Design, Architecture, Art, and Planning',
              title: `Dean's List`,
              canCollapse: false,
              dates: ['2019'],
              dateNames: [],
              info: []
            }
          ]
        },
        {
          name: "Volunteering",
          isExpanded: false,
          showcase: 'resume',
          cards: [
            {
              subtitle: '',
              title: 'Beautification Sunday',
              canCollapse: false,
              dates: ['2017'],
              dateNames: [],
              info: []
            },
            {
              subtitle: '',
              title: 'VOICE',
              canCollapse: false,
              dates: ['2016'],
              dateNames: [],
              info: []
            },
            {
              subtitle: '',
              title: 'Mission for Mars',
              canCollapse: false,
              dates: ['2016 / 2018'],
              dateNames: [],
              info: []
            },
            {
              subtitle: '',
              title: 'Ronald McDonald House',
              canCollapse: false,
              dates: ['2016 / 2018'],
              dateNames: [],
              info: []
            },
            {
              subtitle: 'Light of Life',
              title: 'Rescue Mission',
              canCollapse: false,
              dates: ['2016'],
              dateNames: [],
              info: []
            },
            {
              subtitle: '',
              title: 'Fellowship Dinner',
              canCollapse: false,
              dates: ['2016'],
              dateNames: [],
              info: []
            },
            {
              subtitle: '',
              title: 'Urban Impact',
              canCollapse: false,
              dates: ['2015'],
              dateNames: [],
              info: []
            },
            {
              subtitle: '',
              title: 'Soles for Jesus',
              canCollapse: false,
              dates: ['2015'],
              dateNames: [],
              info: []
            },
          ]
        }
      ],
      workItems: [
        {
          name: "5 Spaces",
          showcase: 'work'
        },
        {
          name: "Hanselmann House",
          showcase: 'work'
        },
        {
          name: "Ice Pavillion",
          showcase: 'work'
        },
        {
          name: "Studio",
          showcase: 'work'
        },
        {
          name: "Unit Wall",
          showcase: 'work'
        }
      ]
    }
  },
  mounted() {
    this.changeLocation(this.location)
  },
  methods: {
    toggleExpand(item) {
      let i = this.resumeItems.findIndex(resItem => resItem === item)
      this.resumeItems[i].isExpanded = !this.resumeItems[i].isExpanded
    },
    expandAll() {
      this.resumeItems.forEach(item => (item.isExpanded = true))
    },
    collapseAll() {
      this.resumeItems.forEach(item => (item.isExpanded = false))
    },
    changeLocation(id) {
      let elm = document.getElementById(id)
      if (elm !== null) {
        setTimeout(() => { elm.scrollIntoView({ behavior: "smooth" }) }, 10)
      }
    }
  },
  watch: {
    location() {
      this.changeLocation(this.location)
    }
  },
}
